import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ShoppingGuide from "@/pages/shopping-guide/page";
import BlogCompleteGuide from "@/pages/blog/complete-guide/page";
import BlogShippingCost from "@/pages/blog/shipping-cost-guide/page";
import BlogReview2026 from "@/pages/blog/review-2026/page";
import BlogCouponGuide from "@/pages/blog/coupon-discount-guide/page";
import BlogWarehouseGuide from "@/pages/blog/warehouse-guide/page";
import BlogAlternatives from "@/pages/blog/vs-alternatives/page";
import BlogBeginnerGuide from "@/pages/blog/beginner-guide/page";
import BlogSafetySecurity from "@/pages/blog/safety-security/page";
import BlogProductTips from "@/pages/blog/product-finding-tips/page";
import BlogTutorial from "@/pages/blog/spreadsheet-tutorial/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/blog/basetao-spreadsheet-complete-guide",
    element: <BlogCompleteGuide />,
  },
  {
    path: "/blog/basetao-shipping-cost-guide",
    element: <BlogShippingCost />,
  },
  {
    path: "/blog/basetao-review-2026",
    element: <BlogReview2026 />,
  },
  {
    path: "/blog/basetao-coupon-discount-guide",
    element: <BlogCouponGuide />,
  },
  {
    path: "/blog/basetao-warehouse-guide",
    element: <BlogWarehouseGuide />,
  },
  {
    path: "/blog/basetao-vs-alternatives",
    element: <BlogAlternatives />,
  },
  {
    path: "/blog/basetao-beginner-guide",
    element: <BlogBeginnerGuide />,
  },
  {
    path: "/blog/basetao-safety-security",
    element: <BlogSafetySecurity />,
  },
  {
    path: "/blog/basetao-product-finding-tips",
    element: <BlogProductTips />,
  },
  {
    path: "/blog/basetao-spreadsheet-tutorial",
    element: <BlogTutorial />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;